import { getVideoEmbedInfo } from 'shared/api'
import { CreationToolVideoInfo } from '../types'
import { getUrlMimeType } from './get-source-info'

const getVideoInfo = (videoUrl: string): Promise<CreationToolVideoInfo> =>
    new Promise(async (resolve, reject) => {
        const mimeType = getUrlMimeType(videoUrl)

        // youtube/vimeo
        if (mimeType === 'youtube' || mimeType === 'vimeo') {
            try {
                const { duration, privacy, title, width, height } = await getVideoEmbedInfo(
                    videoUrl.replace(/(^\w+:|^)\/\//, '')
                )
                resolve({
                    duration,
                    width,
                    height,
                    title,
                    isPrivate: privacy && !privacy.download,
                })
            } catch (err) {
                reject(err)
            }
        }

        const video = document.createElement('video')
        video.onloadedmetadata = () => {
            resolve({
                duration: video.duration,
                width: video.videoWidth,
                height: video.videoHeight,
            })
        }
        video.onerror = reject
        video.src = videoUrl
    })

export default getVideoInfo
